module.exports = __webpack_public_path__ + "img/4.27043c48.png";